import { AxiosResponse } from 'axios';

import { instance } from '@/lib';

const saveBlob = (response: AxiosResponse<Blob>, filename: string) => {
  const href = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', `${filename}.xlsx`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export const downloadSurveyAnswersReport = async (globalId: string, reportName: string) => {
  const response = await instance.get('/reports/download', {
    params: {
      reportType: 'surveyAnswers',
      reportFormat: 'xlsx',
      globalId,
    },
    responseType: 'blob',
  });

  saveBlob(response, reportName);
};
